/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid, Hidden } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { Breadcrumbs } from '@navigation';
import { ConfirmationModal } from '@components';
import { setModal } from '@store/common/actions';
import { updateUserRole } from '@services/users-service';
import { setUserSelected } from '../../redux/users/actions';
import Roles from '../../components/RolesCarusel';
import { showError } from '../../redux/logged/actions';
import { successResponsive } from '../../constants/errorObjects';
import * as Routes from '../../constants/routes';

class UserRoleEdit extends Component {
  constructor() {
    super();
    this.state = {
      mobile: window.innerWidth < 1280,
    };
  }

  handleRoleChange = (name) => {
    this.props.dispatchShowModal(() =>
      updateUserRole(
        { roles: name, idUser: this.props.selected._id },
        this.successUpdate,
        this.errorUpdate
      )
    );
  };

  successUpdate = (data) => {
    this.props.dispatchSetUserSelected(data);
    this.props.dispatchShowError(successResponsive('Edición guardada'));
    this.props.history.push(Routes.USER_DETAIL);
  };

  errorUpdate = () => {
    this.props.history.push(Routes.EDIT_ROLE_ERROR, {
      firstLineCode: 'editCollaborator.error.title',
      subTextCode: 'editCollaborator.error.subtitle',
      buttonTextCode: 'editCollaborator.error.buttonText',
      nextPage: Routes.USERS,
    });
  };

  render() {
    const { route } = this.props;
    return (
      <>
        {!this.state.mobile && (
          <Grid item container xs={12}>
            <Hidden mdDown>
              <Breadcrumbs route={route} />
            </Hidden>
          </Grid>
        )}
        <Roles
          hideTitle
          selection={this.props.selected.roles[0]}
          edit
          handleClick={this.handleRoleChange}
        />
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  loading: state.users.loading,
  selected: state.users.selected,
  field: state.users.field,
  logged_doc: state.login.loguedAs.doc_number,
});
const mapDispatchToProps = (dispatch, props) => {
  const { t } = props;
  return bindActionCreators(
    {
      dispatchSetUserSelected: setUserSelected,
      dispatchShowError: showError,
      dispatchShowModal: (handleConfirm) =>
        setModal({
          open: true,
          ...{
            body: (
              <ConfirmationModal
                title={t('editCollaborator.modal.message')}
                handleConfirm={handleConfirm}
              />
            ),
          },
        }),
    },
    dispatch
  );
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(UserRoleEdit));
